import React from "react";
import "./Footer.css";

export default function Footer({ logo }) {
  return (
    <footer className="footer">
      <p>© 2026</p>
      {logo ? <img className="footer-logo" src={logo} alt="SamviDdhi Logo" /> : null}
    </footer>
  );
}
